export enum MediaObjectType {
  TestRubric = 'testRubric',
  TestInstanceResponse = 'testInstanceResponse'
}

export type BaseMediaObject = API_JSON & {
  name: string;
  displayName: string;
  fileName: string;
  mimeType: string;
  type: MediaObjectType;
  contentUrl: string;
  order: number;
};
